import { RootState } from "src/app/model/store";
import { ModalIDs } from "src/shared/config";

export const selectModalByID = (state: RootState, id: ModalIDs) => {
  return state.modal[id];
};
